import { styled } from "styled-components";

export const MainNav = styled.ul`
  display: flex;
  gap: 30px;
  margin-right: 140px;
  list-style: none;
`;